import { BrowserRouter, Routes, Route } from 'react-router-dom';
import NewsAnalyser from './NewsAnalyser';
import HowItWorks from './HowItWorks';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<NewsAnalyser />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;